export function Outside(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.341 8.36201L21.3527 6.3L20.2817 6.3C19.9692 6.3 19.6853 6.48192 19.5548 6.76581L16.6256 13.1368C16.1366 14.2004 15.1094 14.9062 13.9541 14.9913C13.4931 16.0555 12.4335 16.8 11.2 16.8C9.5431 16.8 8.19995 15.4568 8.19995 13.8C8.19995 12.1431 9.5431 10.8 11.2 10.8C12.4183 10.8 13.4671 11.5263 13.9368 12.5696C14.1583 12.5067 14.3459 12.3499 14.4451 12.1342L17.3743 5.76324C17.8964 4.62767 19.0318 3.9 20.2817 3.9L21.2502 3.9L19.3622 2.0592C18.8877 1.59654 18.8781 0.836804 19.3407 0.36228C19.8034 -0.112243 20.5631 -0.12186 21.0376 0.3408L24.3214 3.54248C25.1916 4.39088 25.209 5.78411 24.3603 6.654L21.0589 10.038C20.596 10.5124 19.8363 10.5217 19.3619 10.0589C18.8876 9.59613 18.8782 8.83639 19.341 8.36201Z"
          fill="currentColor"
        />
        <path
          d="M3.51848 12.4455C4.26652 8.20315 8.31206 5.37044 12.5544 6.11848C13.2071 6.23357 13.8295 5.79777 13.9446 5.14509C14.0597 4.49242 13.6239 3.87003 12.9712 3.75495C7.42346 2.77673 2.13315 6.48105 1.15494 12.0288C0.176723 17.5765 3.88104 22.8668 9.42876 23.845C14.9765 24.8232 20.2668 21.1189 21.245 15.5712C21.3601 14.9185 20.9243 14.2961 20.2716 14.181C19.6189 14.066 18.9966 14.5018 18.8815 15.1544C18.1334 19.3968 14.0879 22.2295 9.84552 21.4815C5.60314 20.7334 2.77043 16.6879 3.51848 12.4455Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
